module.exports = __webpack_public_path__ + "img/logo-full-lg.f7b5ebd1.png";